import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, Flex, Text } from "@mantine/core";
import { DonutChart } from "@mantine/charts";
import { routes } from "../../../utils/vars";

const UpForTodayChart = ({ assigned, pending, user, chartData, t }) => {
  const navigate = useNavigate();

  const clickHandler = (type) => {
    if (type === "assignee") {
      const name = user.name ? encodeURIComponent(user.name.toLowerCase()) : "";
      navigate(`${routes.MONITORING_QUEUE}?assignee=${name}`);
    }

    if (type === "status") {
      navigate(`${routes.MONITORING_QUEUE}?status=pending`);
    }
  };

  return (
    <Card
      withBorder
      style={(theme) => ({
        height: 210,
        backgroundColor: theme.colors.gray[1],
        borderColor: theme.colors.gray[2],
      })}
    >
      <Flex
        pb={10}
        pt={10}
        direction="row"
        align="center"
        justify="space-between"
      >
        <Flex direction="column" justify="center">
          <Text size="sm">Assigned - {assigned}</Text>
        </Flex>
        <DonutChart
          thickness={15}
          withLabelsLine
          strokeWidth={0}
          labelsType="value"
          size={130}
          startAngle={-270}
          endAngle={270}
          data={chartData}
        />
        <Flex direction="column" justify="center">
          <Text size="sm">Pending - {pending}</Text>
        </Flex>
      </Flex>

      <Text size="xs" c="dimmed">
        {t("homePage.forTodayPart1")}{" "}
        <Text
          size="xs"
          c="blue"
          component="span"
          className="link"
          onClick={() => clickHandler("assignee")}
        >
          {assigned}
        </Text>{" "}
        {t("homePage.forTodayPart2")}{" "}
        <Text
          size="xs"
          c="blue"
          component="span"
          className="link"
          onClick={() => clickHandler("status")}
        >
          {pending || "0"}
        </Text>{" "}
        {t("homePage.forTodayPart3")}
      </Text>
    </Card>
  );
};

export default UpForTodayChart;
